<template>
    <div>
        <v-tooltip bottom color="secondary">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    depressed
                    v-bind="attrs"
                    v-on="on"
                    :disabled="disabled"
                    small
                    :ripple="false"
                    @click="$emit('click')"
                    color="white"
                >
                    <v-icon small color="primary">{{icon}}</v-icon>
                </v-btn>
            </template>
            <div class="d-flex align-center">
                <v-icon class="mr-1" color="inverse">mdi-hand-pointing-right</v-icon>
                <h1 class="text-body-subtitle-inverse">{{smsTooltip}}</h1>
            </div>
        </v-tooltip>
    </div>
</template>
<script>
export default {
    props: {
        icon: String,
        smsTooltip: String,
        disabled: Boolean
    }
}
</script>
